import { action, makeObservable, observable } from 'mobx';

class VideoLoadedStore {
  loadedVideo = {
    // lobbyVideo: false,
    gameVideo: false,
  };

  constructor() {
    makeObservable(this, {
      loadedVideo: observable.deep,
      setLoadedVideo: action.bound,
    });
  }

  setLoadedVideo(videoName, state) {
    this.loadedVideo[videoName] = state;
  }

  resetLoadedVideo() {
    this.loadedVideo = {
      // lobbyVideo: false,
      gameVideo: false,
    };
  }
}

export const videoLoadedStore = new VideoLoadedStore();
